import React from "react";
import { useTranslation } from "react-i18next";
import aboutImg from "../../../assets/images/abouttHero.jpg";

const ArdrendScholarshipPanel = () => {
  const { t } = useTranslation();
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      <div className="max-w-[1560px] mx-auto px-3 sm:px-6">
        <div className="bg-gradient-to-br from-[#1a2333] via-[#0b0f19] to-[#05070c] border border-white/10 backdrop-blur-xl rounded-[20px] overflow-hidden flex flex-col lg:flex-row shadow-2xl relative">
          <div className="absolute top-0 right-0 w-64 h-64 bg-primary rounded-full mix-blend-screen filter blur-[100px] opacity-30 animate-pulse"></div>
          
          <div className="w-full lg:w-1/2 p-8 sm:p-12 lg:p-20 flex flex-col justify-center relative z-10">
            <div className="text-[13px] font-bold tracking-[0.15em] uppercase text-primary mb-6 flex items-center gap-3">
              <span className="block w-8 h-[2px] bg-primary"></span>
              {t("home.scholarshipPanel.kicker")}
            </div>
            <h2 className="text-white text-4xl md:text-5xl font-bold mb-6 leading-tight">
              {t("home.scholarshipPanel.titlePrefix")}<span className="text-primary">{t("home.scholarshipPanel.titleHighlight")}</span>{t("home.scholarshipPanel.titleSuffix")}
            </h2>
            <p className="text-gray-400 text-xl mb-10 leading-relaxed">
              {t("home.scholarshipPanel.text")}
            </p>
            <div className="flex flex-col gap-3 items-start">
              <a href="https://app.e1xacademy.net/innovate-hub-schorlaship" target="_blank" rel="noopener noreferrer" className="bg-primary hover:bg-[#b0451e] text-white transition-colors rounded-full pl-6 pr-2 py-3 inline-flex items-center justify-between gap-4 group shadow-md">
                <span className="font-bold uppercase tracking-wider text-[13px]">{t("home.scholarshipPanel.apply")}</span>
                <div className="w-9 h-9 rounded-full bg-white flex items-center justify-center text-primary group-hover:bg-[#0b0f19] group-hover:text-white transition-colors shrink-0">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="w-4 h-4 transition-transform group-hover:translate-x-0.5">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                  </svg>
                </div>
              </a>
              <a href="https://app.e1xacademy.net/innovate-hub-schorlaship" target="_blank" rel="noopener noreferrer" className="bg-transparent border border-white/20 hover:bg-white/10 text-white transition-colors rounded-lg px-6 py-3.5 text-center font-bold uppercase tracking-wider text-[13px]">
                {t("home.scholarshipPanel.viewEligible")}
              </a>
            </div>
          </div>
          
          <div className="w-full lg:w-1/2 relative min-h-[400px]">
            <img src={aboutImg} alt="Students" className="absolute inset-0 w-full h-full object-cover object-center opacity-80" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0b0f19] via-[#0b0f19]/40 to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArdrendScholarshipPanel;
